import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { sort } from 'fast-sort';
import { supabase } from '../../supabaseClient';

/**
 * Hook para carregar lista de empresas do usuário.
 * Super admins: busca todas via Supabase (query leve, sem ContractHistory).
 * Usuários normais: usa userCompanies já carregadas no Redux pelo login.
 */
export function useCompanies() {
  const user = useSelector((state) => state.app.user || {});
  const userCompanies = useSelector((state) => state.app.userCompanies || []);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  const isSuperAdmin = !!user.isSuperAdmin;

  useEffect(() => {
    if (!isSuperAdmin) {
      setCompanies(userCompanies);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    supabase
      .from('Company')
      .select('id, name, logo, active')
      .is('deleted_at', null)
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) {
          console.error('Erro ao carregar empresas:', error);
        } else if (data?.length) {
          setCompanies(sort(data).asc((c) => c.id));
        }
        setLoading(false);
      });

    return () => { cancelled = true; };
  }, []);

  return { companies, loading };
}
